<template>
    <v-app>
        <v-app-bar app dense color="primary" dark>
            <div class="d-flex align-center">
                <v-img
                    alt="DentalManik"
                    class="shrink mr-2"
                    contain
                    src="/assets/img/logo-dentalmanik-500x500.svg"
                    transition="scale-transition"
                    width="40"
                />

                <v-toolbar-title><b>DentalManik</b></v-toolbar-title>
            </div>

            <div id="divRoutes">
                <div v-if="!usuario">
                    <router-link :to="{ name: 'inicio' }" tag="span"
                        >Inicio</router-link
                    >
                </div>
                <div v-else>
                    <router-link :to="{ name: 'agenda' }" tag="span"
                        >Agenda</router-link
                    >
                    <router-link :to="{ name: 'pacientes' }" tag="span"
                        >Pacientes</router-link
                    >
                    <router-link
                        :to="{ name: 'categorias' }"
                        tag="span"
                        v-if="!usuario.roles.includes('ASI')"
                        >Prestaciones</router-link
                    >
                    <router-link
                        :to="{ name: 'asistentes' }"
                        tag="span"
                        v-if="!usuario.roles.includes('ASI') && !isGroup"
                        >Asistentes</router-link
                    >
                    <!--Configuración/facturacion-->

                    <v-menu bottom center v-if="(usuario.roles.includes('MED') || usuario.roles.includes('ASI')) && usuario.isoPais == 'MX'">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dark
                                icon
                                v-bind="attrs"
                                v-on="on"
                                title="Facturación electrónica"
                            >
                                <v-icon>mdi-file-document-multiple-outline</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, i) in filteredItems"
                                :key="i"
                                @click="goOptTimbrado(item.path)"
                            >
                                <v-list-item-icon v-if="item.icon">
                                    <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{
                                    item.text
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>



                    <!--Configuración/administración-->
                    <v-menu bottom center v-if="usuario.roles.includes('MED') && !isGroup">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dark
                                icon
                                v-bind="attrs"
                                v-on="on"
                                title="Administración"
                            >
                                <v-icon>mdi-cog-outline</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, i) in administracionItems"
                                :key="i"
                                @click="go(item.to)"
                            >
                                <v-list-item-icon>
                                    <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{
                                    item.text
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>

            <v-spacer></v-spacer>

            <v-menu left bottom v-if="usuario">
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" title="Mi perfil">
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>

                <!-- PENDIENTE: validar para asistente> -->
                <v-card class="text-center" max-width="400">
                    <img v-if="usuario.roles.includes('MED')"
                        :src="
                            'data:image/jpg;base64,' +
                            (usuario.avatar ? usuario.avatar : defaultAvatar)
                        "
                        width="100"
                        class="mt-2"
                        style="cursor: pointer"
                        title="Clic para modificar tus datos de perfil"
                        @click="goPerfil()"
                    />

                    <v-card-subtitle class="pt-3 pb-2">{{etiquetaMedico}}{{
                        usuario.nombres + " " + usuario.apellidos
                    }}</v-card-subtitle>

                    <v-card-subtitle class="pt-0 pb-2">{{
                                            usuario.correo
                                        }}</v-card-subtitle>

                    <v-card-text class="text--primary">
                        <div><b>Vigencia suscripción</b></div>
                        <div>
                            {{
                                formatearFechaIsoAMx(
                                    usuario.suscripcion.fechaInicio
                                )
                            }}
                            -
                            {{
                                formatearFechaIsoAMx(
                                    usuario.suscripcion.fechaFin
                                )
                            }}
                        </div>
                    </v-card-text>

                    <v-card-actions v-if="usuario.roles.includes('MED') && !isGroup">
                        <v-btn
                            color="#07446a"
                            text
                            @click="$router.push({ name: 'comprar' })"
                        >
                            <v-icon>mdi-credit-card-plus-outline</v-icon>
                            Comprar
                        </v-btn>

                        <v-btn color="#07446a" text @click="historial">
                            <v-icon>mdi-cart</v-icon>
                            Historial
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>

            <v-btn
                icon
                title="Curriculum vitae"
                @click="goCV()"
                v-if="usuario && !usuario.roles.includes('ASI')"
            >
                <v-icon>mdi-note-text</v-icon>
            </v-btn>
            <v-btn icon v-if="usuario">
                <v-icon @click="logout">mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>

        <v-main>
            <v-container fluid class="mt-0 pt-0">
                <router-view
                    v-if="
                        (usuario || unrestricted.includes($route.name)) &&
                        loaded
                    "
                ></router-view>
            </v-container>
        </v-main>
        <v-footer class="mt-2 font-weight-medium" color="grey lighten-3">
            Copyright © {{ new Date().getFullYear() }} Datateam Consulting, S.A.
            de C.V.
        </v-footer>

        <v-snackbar
            v-model="$root.alert"
            :timeout="$root.timeoutAlert"
            :multi-line="true"
            :color="$root.colorAlert"
        >
            <span>
                <span style="font-size: 16px; font-weight: 400"
                    >{{ $root.messageAlert }}&nbsp;</span
                >
            </span>
            <v-btn
                color="white"
                text
                @click="
                    $root.alert = false;
                    $event.stopPropagation();
                "
                >Cerrar</v-btn
            >
        </v-snackbar>
        <v-dialog v-if="show" v-model="show"  max-width="450" scrollable>
             <permisos @close="show=false" v-if="comp =='permisos'"></permisos>
        </v-dialog>
    </v-app>


</template>

<style>
#divRoutes {
    margin-left: 3em;
}
#divRoutes span {
    color: white;
    margin: 0 10px;
    cursor: pointer;
}
.router-link-exact-active {
    font-weight: bold;
}
</style>

<script>
import { Urls } from "@/consts.js";
import { formatearFechaIsoAMx } from "@/utils.js";
let comps=['permisos'];

export default {
    components:{
      Permisos: () => import('@/components/Permisos'),
    },
    data: () => ({
        //
        comp:'',
        administracionItems: [
            {
                text: "Formato receta",
                icon: "mdi-prescription",
                to: "FormatoReceta",
            },
            {
                text: "Consultorios",
                icon: "mdi-hospital-building",
                to: "Consultorios",
            },
            {
                text: "Logotipo",
                icon: "mdi-file-image",
                to: "logotipo",
            },
            {
                text: "Permisos asistentes",
                icon: "mdi-account-cog",
                to: "permisos"
            }
        ],
        facturacionItems:[
            {
                text:"Datos fiscales",
                icon:"mdi-account-details",
                path:"dfe",
                show: function (){ return this.usuario.roles.includes('MED');}
            },
            {
                text:"Configuración adicional",
                icon:"mdi-file-cog",
                path:"config",
                show: function (){ return this.usuario.roles.includes('MED');}
            },
            {
                text:"Generar factura",
                icon:"mdi-alpha-f-box-outline",
                path:"generar/1",
                show:function(){ return (this.usuario.roles.includes('MED') || this.usuario.roles.includes('ASI'))}
            },
            {
                text:"Generar recibo por honorarios",
                icon:"mdi-alpha-r-box-outline",
                path:"generar/0",
                show:function(){return (this.usuario.roles.includes('MED') || this.usuario.roles.includes('ASI'))}
            },
            {
                text:"Facturas",
                icon:"mdi-view-list",
                path:"facturas",
                show:function(){return (this.usuario.roles.includes('MED') || this.usuario.roles.includes('ASI'))}
            }


        ],
        unrestricted: ["inicio", "registro", "activarCuenta","paquetes"],
        defaultAvatar:
            "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",
        show:false
    }),
    computed: {
        filteredItems() {
            return this.facturacionItems.filter((e) => e.show.apply(this));
        },
        usuario: function () {
            return this.$store.state.usuario;
        },
        isGroup: function(){
            return this.$store.state.group;
        },
        etiquetaMedico:function(){
            return (this.usuario.roles.includes("MED"))?(this.usuario.genero == "F" ? "Dra. ":"Dr. ") : "";
        },
        loaded:function(){
            return this.$root.loaded;
        }
    },
    methods: {
        goOptTimbrado(path){
            if(path && path != "" && this.usuario.sessionUuid){

                var location = process.env.VUE_APP_COMPRAS_URL+"/cfdi/"+path+"?at="+this.usuario.sessionUuid;

                window.open(location);
            }
        },
        iniciarSesion: function () {            
            const w = window.location.href;
            if (w.indexOf("/public/")>-1) {                        
                this.$root.setLoaded(true);                
                this.$store.commit("usuario", null);                
                return;
            }
            let at = this.$route.query.at ?? null;
            if (at) {
                this.$http
                    .get("/session/login?at=" + at)
                    .then((data) => {
                        this.setUsuario(data);
                    });
            } else {
                this.$http.get(Urls.USUARIOS_URL).then((data) => {
                    this.setUsuario(data);
                });
            }
        },
        setUsuario(data) {
            if (data) {
                this.$store.commit("usuario", data);
                let contenido = JSON.parse(this.usuario.suscripcion.contenido);
                let isGroup = contenido.cuenta_id == 3;
                this.$store.commit("group",isGroup);
                if (!this.usuario.isVigente) {
                    this.$root.showMessage(
                        "Tu cuenta ha expirado. ¡Compra tu licencia ahora!", 'warning'
                    );
                    if (this.$route.name != "comprar" && this.$route.query.at) {
                        this.$router.push({ name: "comprar" });
                    }
                } else if (this.$route.name == "inicio") {
                    this.$router.push({ name: "agenda" });
                }
            } else if (!this.unrestricted.includes(this.$route.name)) {
                this.$store.commit("usuario", null);
                window.location.href = process.env.VUE_APP_SSO_URL;
            }
        },
        logout: function () {
            this.$root.logout();
        },
        getDatosPrecargados: function () {//no requiere sesión
            this.$http.get("/public/classification").then((data) => {
                if (!data) return;
                this.$store.commit("simbologia", data.simbologia);
                this.$store.commit("paises", data.paises);
                this.$store.commit("especialidades", data.especialidades);
                this.$root.setLoaded(true);
            });
        },
        historial: function () {
            window.open(
                process.env.VUE_APP_COMPRAS_URL +
                    "/compras?at=" +
                    this.usuario.sessionUuid
            );
        },
        go: function (to) {
            if (to ) {
                if(comps.includes(to)){
                    this.show = true;
                    this.comp = to;
                }
                else if(this.$router.currentRoute.name != to){
                    this.comp = '';
                    this.show = false;
                    this.$router.push({ name: to });

                }
            }
        },
        formatearFechaIsoAMx(fecha) {
            return formatearFechaIsoAMx(fecha);
        },
        goPerfil: function () {
            window.open(
                process.env.VUE_APP_PANEL_URL +
                    "/perfil?at=" +
                    this.usuario.sessionUuid
            );
        },
        goCV: function () {
            window.open(
                process.env.VUE_APP_PANEL_URL +
                    "/cv?at=" +
                    this.usuario.sessionUuid
            );
        },
    },
    beforeMount() {
        this.getDatosPrecargados();
        this.iniciarSesion();
    },
};
</script>
<style>
.text-color-title {
    color: #07446a;
}
</style>
